import * as React from "react"
import {
  TextInput,
  SelectInput,
  ImageInput,
  ImageField,
  ReferenceInput,
  ArrayInput,
  SimpleFormIterator,
  BooleanInput,
  NumberInput,
  useDataProvider,
  SimpleForm,
  SaveButton,
  DeleteWithConfirmButton
} from "react-admin"
import { Box, Grid, Toolbar } from "@mui/material"
import { useWatch, useFormContext } from 'react-hook-form';
import { useEffect, useRef } from "react"

const PrintingMethodToolbar = ({formType}) => {
  return (
    <Toolbar>
      <Box display="flex" justifyContent="space-between" width="100%">
        {/* 儲存按鈕 (始終顯示) */}
        <SaveButton />
        {/*
          條件渲染刪除按鈕：
          1. 只在編輯模式顯示 (formType === "edit")
        */}
        { formType === "edit" && (
          <DeleteWithConfirmButton
            confirmTitle="確認刪除"
            confirmContent="您確定要刪除此印製方式嗎？"
          />
        )}
      </Box>
    </Toolbar>
  );
};

const validateForm = async (values) => {
  const errors = {}
  if (!values.name) {
    errors.name = "ra.validation.required"
  }
  if (!values.methodImage?.rawFile && !values.methodImage?.[0]?.title) {
    errors.methodImage = "ra.validation.required"
  }

  return errors
}

const PrintingMethodForm = ({formType}) => {
  const prevFileRef = useRef(null);

  const CustomImageInput = () => {
    const { setValue, getValues } = useFormContext();
    const uploadedImage = useWatch({ name: 'methodImage' });
    const isInitialMount = useRef(true);

    useEffect(() => {
      // 跳過初次渲染
      if (isInitialMount.current) {
        isInitialMount.current = false;
        return;
      }

      // 只有當真正有新文件上傳時才處理
      if (uploadedImage?.rawFile && uploadedImage.rawFile !== prevFileRef.current) {
        const currentFile = uploadedImage.rawFile;
    
        // 檢查是否是有效的 File 對象
        const isValidFile = (
          currentFile &&
          typeof currentFile === 'object' &&
          currentFile instanceof File
        );

        if (!isValidFile) {
          // 不是有效文件時不做任何操作
          return;
        }

        prevFileRef.current = currentFile;
      }
    }, [uploadedImage, setValue]);

    return (
      <ImageInput 
        source="methodImage" 
        label="圖片(PNG 或 JPG)"
        accept={{
          "image/png": [".png"],
          "image/jpeg": [".jpg", ".jpeg"],
        }}
      >
        <ImageField source="src" title="title" />
      </ImageInput>
    );
  };

  return (
    <SimpleForm
      defaultValues={{
        name: "",
        description: "",
        methodImage: [],
      }}
      validate={validateForm}
      toolbar={<PrintingMethodToolbar formType={formType} />}
    >
      <Grid container width={{ xs: "90%", xl: 800 }} spacing={2}>
        <Grid item xs={12}>
          <CustomImageInput />
        </Grid>
        <Grid item xs={12} sm={8}>
          <TextInput autoFocus source="name" label="名稱" inputProps={{ maxLength: 20 }} isRequired />
        </Grid>
        <Grid item xs={12}>
          <TextInput 
            source="description"
            label="描述" 
            multiline
            rows={4}
          />
        </Grid>
      </Grid>
    </SimpleForm>
  )
}

export default PrintingMethodForm